import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { combineLatest, Observable } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';

import { CUSTOM_PRICING_MAP, FREE_PRICING_MAP } from 'app/constants/pricing.data';
import { OfferProductPosition } from 'graphql/models/extended';
import { LineSubtypePropVal } from 'models/position.model';
import { EditArticleInOfferFormComponent } from '../edit-article-in-offer-form/edit-article-in-offer-form.component';
import { OfferPositionService } from 'shared/services/offer-position.service';
import { PricingService } from 'shared/services/pricing.service';
import { StoreService } from 'shared/services/store.service';

@Component({
  selector: 'app-edit-article-in-offer-modal',
  templateUrl: './edit-article-in-offer-modal.component.html',
  styleUrls: ['./edit-article-in-offer-modal.component.scss']
})
export class EditArticleInOfferModalComponent {
  @ViewChild(EditArticleInOfferFormComponent) editArticleInOfferFormComponent!: EditArticleInOfferFormComponent;

  get form(): UntypedFormGroup {
    return this.editArticleInOfferFormComponent.form;
  }

  constructor(
    private offerPositionService: OfferPositionService,
    private pricingService: PricingService,
    private storeService: StoreService
  ) {
  }

  onSubmit(): Observable<any> {
    const offer = this.editArticleInOfferFormComponent.offer;
    const position = this.editArticleInOfferFormComponent.position;
    const positionId = position.id;
    const isDealer = this.editArticleInOfferFormComponent.isDealer;
    const articleForm = this.form.controls.article as UntypedFormGroup;
    let articleProps = { ...articleForm.value };

    if (articleProps.category) {
      articleProps = {
        ...articleProps,
        category: {
          displayName: articleProps.category
        }
      }
    }
    const articleData = JSON.stringify(articleProps);

    return this.offerPositionService.updateAllPositionFields(
      offer,
      position.id,
      position?.quantity?.value || 1,
      position.description || '',
      position?.positionNumber || '',
      this.form.controls.text.value,
      (isDealer ? articleForm.controls.id.value : ''),
      (isDealer ? LineSubtypePropVal.MY_ARTICLE : LineSubtypePropVal.FREE_ARTICLE),
      articleForm.controls.name.value,
      articleForm.controls.description.value || '',
      articleData
    ).pipe(
      concatMap(() => {
        const values = [];
        const listPriceStepId = (isDealer ? CUSTOM_PRICING_MAP.listPrice : FREE_PRICING_MAP.listPrice);
        const listPrice = {
          lineId: listPriceStepId,
          stepId: listPriceStepId,
          value: articleForm.controls.listPrice.value
        };

        values.push(listPrice);

        if (isDealer) {
          values.push({
            lineId: CUSTOM_PRICING_MAP.basePrice,
            stepId: CUSTOM_PRICING_MAP.basePrice,
            value: articleForm.controls.purchasePrice.value
          });
        }

        return combineLatest(values.map((price) => (
          this.pricingService.updatePricing(offer, positionId, price, true)
        )))
      }),
      concatMap(() => this.offerPositionService.getArticleProductPosition(offer, position.id)),
      tap((productPosition: OfferProductPosition) => this.storeService.setOfferUpdate({
        customProductPositionUpdate: productPosition
      })),
      tap(() => this.storeService.resetCustomPosition())
    );
  }

  onClose(): void {
    this.storeService.resetCustomPosition();
  }
}
